// Tiny metronome click built on the Web Audio API. The AudioContext is created
// on the first click, which happens inside the spacebar press, so browsers
// allow it to play.
export function createClicker() {
  let ctx = null;

  const getContext = () => {
    if (!ctx) {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextClass) return null;
      ctx = new AudioContextClass();
    }
    if (ctx.state === 'suspended') ctx.resume();
    return ctx;
  };

  return {
    /** volume is 0 to 1; accent gives the downbeat a higher pitch. */
    click(volume, accent = false) {
      if (volume <= 0) return;
      const audio = getContext();
      if (!audio) return;

      const now = audio.currentTime;
      const osc = audio.createOscillator();
      const gain = audio.createGain();
      osc.type = 'sine';
      osc.frequency.value = accent ? 1500 : 1000;
      gain.gain.setValueAtTime(0.0001, now);
      gain.gain.exponentialRampToValueAtTime(Math.max(0.0001, volume * 0.6), now + 0.002);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.06);
      osc.connect(gain);
      gain.connect(audio.destination);
      osc.start(now);
      osc.stop(now + 0.07);
    },

    close() {
      if (ctx) {
        ctx.close().catch(() => {});
        ctx = null;
      }
    },
  };
}